const CONTAINER_ID = "chart"

export { CONTAINER_ID }
